import React from "react";
import { Link } from "react-router-dom";
import BasePage from "../../base/BasePage";
import SignUpPresenter from "./SignUpPresenter";
import { signUpUseCase } from "../../usecases/user";
import { updateObjectUseCase } from "../../usecases/object";
import { Button } from "nq-component";
import withRouter from "../../withRouter";
import FormFactory from "../../components/FormFactory";
import schemaSignup from "./schemaSignup";

class SignUpPage extends BasePage {
  constructor(props) {
    super(props);
    this.presenter = new SignUpPresenter(
      this,
      signUpUseCase(),
      updateObjectUseCase()
    );
    this.state = { progress: false };
  }

  formSubmit(e) {
    e.preventDefault();
    this.presenter.submit(this.state.user);
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  render() {
    const isWalkIn = this.props.params.isWalkIn;
    return (
      <div className="vh-100">
        <div className="d-flex h-100">
          <div className="m-auto container p-3 p-lg-5 d-flex justify-content-center">
            <div className="bg-white rounded p-3 w-75">
              <div className="col">
                <div className="">
                  <div className="h-100 d-flex align-items-center">
                    <div className="text-center p-3 w-100">
                      <img
                        className="img-fluid login-img mb-3 w-25"
                        alt="company logo"
                        src="/lgs.jpeg"
                        width="400"
                        height="400"
                      />
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <div className="col-md-6 p-3 px-lg-1 py-lg-4 w-75">
                    <h2
                      className="fw-bold text-center"
                      style={{ color: "#d18237" }}
                    >
                      Sign Up
                    </h2>
                    <p className="text-black-50 text-center mb-5">
                      Enter your details to create an account
                    </p>
                    <form
                      className="w-100"
                      onSubmit={this.formSubmit.bind(this)}
                    >
                      <div className="d-flex justify-content-center">
                        <div className="row g-3">
                          <FormFactory
                            schema={schemaSignup}
                            onChange={this.onChange.bind(this)}
                          />
                          <div className="col-md-12 d-flex justify-content-center w-100">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="signup_cb_terms"
                              />
                              <label
                                className="form-check-label fs-xs"
                                htmlFor="signup_cb_terms"
                              >
                                I agree to the
                                <Link
                                  to="/terms"
                                  target="_blank"
                                  className="text-success"
                                >
                                  {" "}
                                  Terms and Conditions.
                                </Link>
                              </label>
                            </div>
                          </div>
                          <div className="text-center">
                            <Button
                              progress={this.state.progress}
                              style={{ backgroundColor: "#d18237" }}
                              type="submit"
                              className="btn text-white w-25 fw-bold py-2 fs-6"
                            >
                              {this.state.progress
                                ? "Please wait..."
                                : "Sign Up"}
                            </Button>
                          </div>
                          <div className="text-center">
                            <span className="fs-sm text-black-50">
                              Already have an account?
                              <Link
                                to={`/signin/${isWalkIn}`}
                                className="ms-1 text-decoration-underline"
                                style={{ color: "#d18237" }}
                              >
                                Log in
                              </Link>
                            </span>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(SignUpPage);
